import { Link } from 'react-router-dom';
import { Image } from '../../AbstractElements';
import logo from '../../assets/svgs/logo.svg';

const SidebarLogo = () => {

  return (
    <div className="logo-icon-wrapper">
      <Link to={`/dashboard/default`}>
        <Image
          attrImage={{ className: 'img-fluid for-dark', src: `${logo}`, alt: '' }} />
      </Link>
    </div>
  );
};

export default SidebarLogo;